import React from "react";
import { Tooltip, IconButton } from "@material-ui/core";
import classNames from "classnames";
import dashboard from "../../../images/sidebar_icon/dashboard.png";
import users from "../../../images/sidebar_icon/user.png";
import clients from "../../../images/sidebar_icon/Clients.png";
import search from "../../../images/sidebar_icon/search.png";
import requirement from "../../../images/sidebar_icon/requirement.png";
import empDashboard from "../../../images/sidebar_icon/emp-dashboard.png";
import profileIcons from "../../../images/employee/sidebar/profile.png";


import useStyles from "../styles";
import SidebarLink from "../components/SidebarLink/SidebarLink";
import { jwtDecode } from "jwt-decode";

const HiringManagerSidebar = ({ location, isSidebarOpened }) => {
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const companyType = decode.companyType;
  const classes = useStyles();
  const hiringManagerItems = [
    {
      id: 0,
      label: "Live Status",
      link: "/app/dashboard",
      view: true,
      icon: (
        <Tooltip title="Live Status" placement="right">
          <IconButton>
            <img
              src={dashboard}
              alt="dashboard"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 1,
      label: "My Dashboard",
      link: "/app/employee_dashboard",
      view: true,
      icon: (
        <Tooltip title="My Dashboard" placement="right">
          <IconButton>
            <img
              src={empDashboard}
              alt="employee dashboard"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 2,
      label: "Profile",
      link: "/app/profile",
      view: true,
      icon: (
        <Tooltip title="Profile" placement="right">
          <IconButton>
            <img
              src={profileIcons}
              alt="Profile"
              className={classNames(classes.Icon3)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 3,
      label: companyType === "COMPANY" && "Projects",
      link: companyType === "COMPANY" && "/app/projects",
      view: true,
      icon: (
        <Tooltip
          title={companyType === "COMPANY" && "Projects"}
          placement="right"
        >
          <IconButton>
            <img
              src={clients}
              alt="Projects"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 4,
      label: "Requirements",
      link: "/app/requirements",
      view: true,
      icon: (
        <Tooltip title="Requirements" placement="right">
          <IconButton>
            <img
              src={requirement}
              alt="requirement"
              className={classNames(classes.Icon2)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 5,
      label: "Candidates",
      link: "/app/cc_candidates",
      view: true,
      icon: (
        <Tooltip title="Candidates" placement="right">
          <IconButton>
            <img
              src={users}
              alt="candidates"
              className={classNames(classes.Icon3)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 6,
      label: "Search Candidates",
      link: "/app/search",
      view: true,
      icon: (
        <Tooltip title="Search Candidates" placement="right">
          <IconButton>
            <img
              src={search}
              alt="candidates"
              className={classNames(classes.Icon4)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      {hiringManagerItems.map((link) => (
        <SidebarLink
          key={link.id}
          location={location}
          isSidebarOpened={isSidebarOpened}
          {...link}
        />
      ))}
    </>
  );
};

export default HiringManagerSidebar;
